"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var costanti_1 = require("@/costanti");
exports.default = {
    namespaced: true,
    state: {
        numeroAttualeAbbonamenti: null,
        numeroAttualeTessereDelTifoso: null
    },
    mutations: {
        SET_NUMERO_ABBONAMENTI: function (state, payload) { return (state.numeroAttualeAbbonamenti = payload); },
        SET_NUMERO_TESSERE_DEL_TIFOSO: function (state, payload) { return (state.numeroAttualeTessereDelTifoso = payload); }
    },
    actions: {
        getNumeriAttuali: function (_a) {
            var commit = _a.commit, state = _a.state;
            return __awaiter(this, void 0, void 0, function () {
                var data, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, vue_1.default.axios.get('/api/numeri_attuali.json')];
                        case 1:
                            data = (_b.sent()).data[0];
                            // if (state.numeroAttualeAbbonamenti !== data[NUMERO_ABBONAMENTI] || state.numeroAttualeTessereDelTifoso !== data[NUMERO_TESSERE_DEL_TIFOSO])
                            //    (document.getElementById('audio') as HTMLMediaElement).play()
                            commit('SET_NUMERO_ABBONAMENTI', data[costanti_1.NUMERO_ABBONAMENTI]);
                            commit('SET_NUMERO_TESSERE_DEL_TIFOSO', data[costanti_1.NUMERO_TESSERE_DEL_TIFOSO]);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            console.error(error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        postNumeriAttuali: function (_a, dati) {
            var commit = _a.commit, dispatch = _a.dispatch, rootState = _a.rootState;
            return __awaiter(this, void 0, void 0, function () {
                var error_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, vue_1.default.axios.patch('/api/numeri_attuali/1/', dati)
                                // notifica
                            ];
                        case 1:
                            _b.sent();
                            // notifica
                            dispatch('modal/showNotification', {
                                name: costanti_1.NOTIFICA_INFO,
                                title: 'Fatto'
                            }, { root: true });
                            //
                            dispatch('getNumeriAttuali');
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            // c'è stato un errore
                            dispatch('modal/showNotification', {
                                name: costanti_1.NOTIFICA_ERRORE,
                                title: 'C\'è stato un errore'
                            }, { root: true });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
